import { render } from "./BenefitsComponent.vue?vue&type=template&id=aedaacdc&scoped=true"
const script = {}

import "./BenefitsComponent.vue?vue&type=style&index=0&id=aedaacdc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aedaacdc"]])

export default __exports__